import React from 'react';
import './style.scss';

const closeIcon = '/-/media/Project/FAB2/shared/images/icon_close-blue.svg';
const closeSearch = () => {
  document.getElementById('search-popup-id').classList.remove('show-search-popup');
  document.body.classList.remove('filter-modal-open');
};

const CloseIcon = ({ className }) => (
  <div className={className} onClick={() => closeSearch()}>
    <img src={closeIcon} />
  </div>
);

export default CloseIcon;
